import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="font-heading text-2xl text-primary-400 whitespace-nowrap">
                古古漫画
              </Link>
              <p className="mt-3 text-sm text-background-300 leading-relaxed">
                古古漫画网提供丰富国漫、日漫、韩漫大全，好看的漫画免费全集下拉式阅读。最新漫画每日更新，追更连载极速体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-lg text-background-50 mb-4">漫画分类</h4>
              <ul className="space-y-2">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-lg text-background-50 mb-4">热门推荐</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/comic/1" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    斗破苍穹
                  </Link>
                </li>
                <li>
                  <Link to="/comic/2" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    一人之下
                  </Link>
                </li>
                <li>
                  <Link to="/comic/4" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    我独自升级
                  </Link>
                </li>
                <li>
                  <Link to="/comic/3" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    鬼灭之刃
                  </Link>
                </li>
                <li>
                  <Link to="/comic/8" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    咒术回战
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-lg text-background-50 mb-4">关于我们</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    用户评价
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    联系我们
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    常见问题
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-400">
              &copy; {currentYear} 古古漫画网 - 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}